import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphComponent } from '../graph/graph.component';
import { HydrographModule, HyetographModule } from '@app/shared';

@NgModule({
  declarations: [GraphComponent],
  imports: [CommonModule, HydrographModule, HyetographModule],
})
export class GraphModule {}
